import { ILanguages } from 'src/app/models/languages.interface';



export interface ILanguageState {
    languages: ILanguages;
}

export const initialLanguageState: ILanguageState = {
    languages: null
};
